// Dependencies
import React, { useRef } from "react";
import Image from "components/image-containers/Image/Image.component";

// Material UI Components
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

// Components
import Header from "components/menus/Header/Header.component";
import EvergreenHeader from "features/Evergreen/components/EvergreenHeader/EvergreenHeader.component";
import GenericLinksBar from "features/Evergreen/components/GenericLinksBar/GenericLinksBar.component";
import VehiclesNearYou from "features/Evergreen/components/VehiclesNearYou/VehiclesNearYou.component";
import Description from "features/Evergreen/components/Description/Description.component";
import VideoGallery from "components/video/VideoGallery/VideoGallery.component";
import RecentlyViewed from "features/Evergreen/components/RecentlyViewed/RecentlyViewed.component";
import SimilarVehicles from "features/Evergreen/components/SimilarVehicles/SimilarVehicles.component";
import Footer from "components/menus/Footer/Footer.component";

// Helpers

// Styles
import { comingSoon } from "assets/externalImages";
import { useStyles } from "./Evergreen.styles";

const Evergreen = ({ genericVehicle, specs }) => {
  const classes = useStyles();
  const navRefs = {
    navBar: useRef(null),
    nearYou: useRef(null),
    allAbout: useRef(null),
    reviews: useRef(null),
    comparison: useRef(null),
    description: useRef(null),
    similar: useRef(null),
  };

  const { model } = genericVehicle;
  const { media, name: modelName } = model;
  const makeName = model.make.name;
  const videos = media.filter((medium) =>
    ["youtube"].includes(medium.mediumType),
  );
  const hero = media?.find(({ mediumType }) => mediumType === "hero");
  return (
    <React.Fragment key="body-fragment" data-component="Evergreen">
      <Header />
      <Container
        maxWidth="lg"
        className={classes.evergreenContainer}
        data-cy="evergreen-page"
      >
        <div className={classes.blueBackground} />
        <div className={classes.evergreenHeader}>
          <EvergreenHeader genericVehicle={genericVehicle} />
        </div>
        <div className={classes.imageGalleryContainer}>
          <div className={classes.mainImageContainer}>
            <Image
              className={classes.mainImage}
              src={hero?.url || comingSoon}
              width="1000"
              height="1000"
              alt="Hero"
            />
          </div>
        </div>
        <GenericLinksBar
          genericVehicle={genericVehicle}
          navRefs={navRefs}
          specs={specs}
        />
        <VehiclesNearYou
          genericVehicle={genericVehicle}
          navRef={navRefs.nearYou}
        />
        {/* <AllAbout navRef={navRefs.allAbout} /> */}
        <Description
          genericVehicle={genericVehicle}
          navRef={navRefs.description}
        />
        {videos.length > 0 && (
          <div>
            <Typography
              variant="h2"
              className={classes.vehicleVideosTitle}
              sx={{ pl: 3 }}
              data-cy="videos-title"
            >
              {`${makeName} ${modelName} videos`}
            </Typography>
            <VideoGallery videos={videos} />
          </div>
        )}
        <RecentlyViewed />
        <SimilarVehicles navRef={navRefs.similar} />
      </Container>
      <Footer />
    </React.Fragment>
  );
};

export default Evergreen;
